/* Nautilus CRO - 2026-06-10 - Pula colorway swatch UI */
(function () {
  'use strict';

  // Map: lowercase color name → variant ID string
  var variantIdMap = {};
  // Color clicked before the API response arrived
  var pendingColor = null;

  function loadVariantMap() {
    fetch('/products/pula.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        product.variants.forEach(function (v) {
          if (v.option1) variantIdMap[v.option1.toLowerCase()] = String(v.id);
        });
        if (pendingColor) {
          writeVariantId(pendingColor);
          pendingColor = null;
        }
      })
      .catch(function () {});
  }

  function writeVariantId(colorName) {
    var variantId = variantIdMap[colorName.toLowerCase()];
    if (!variantId) {
      pendingColor = colorName;
      return;
    }
    var idInput =
      document.querySelector('[data-type="add-to-cart-form"] input[name="id"]') ||
      document.querySelector('product-form-component input[name="id"]') ||
      document.querySelector('form[action*="cart"] input[name="id"]');
    if (idInput) idInput.value = variantId;
  }

  // Force the slideshow to navigate to the first visible slide after we toggle
  // [hidden] on slideshow-slide children. Without this, the scroller stays on
  // whatever slide it was previously showing (often a now-hidden one), so the
  // user sees a blank panel or the wrong color until they swipe.
  function resetSlideshow(gallery) {
    var slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow) return;
    var scroller = slideshow.querySelector('[ref="scroller"]') ||
                   slideshow.querySelector('slideshow-slides');
    if (scroller) {
      scroller.scrollLeft = 0;
      scroller.scrollTop = 0;
    }
    if (typeof slideshow.select === 'function') {
      try { slideshow.select(0, undefined, { animate: false }); } catch (e) {}
    }
  }

  function applyColorway(colorway) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    // Mobile / carousel: slideshow-slide elements
    var slides = Array.from(gallery.querySelectorAll('slideshow-slide[data-pula-colorway]'));
    slides.forEach(function (s) {
      if (s.dataset.pulaColorway === colorway) {
        s.removeAttribute('hidden');
        s.style.display = '';
      } else {
        s.setAttribute('hidden', '');
        s.style.display = 'none';
      }
    });

    var matching = slides.filter(function (s) { return s.dataset.pulaColorway === colorway; });
    if (matching.length > 1) {
      var parent = matching[0].parentNode;
      var sorted = matching.slice().sort(function (a, b) {
        return parseInt(a.dataset.pulaOrder || '99', 10) - parseInt(b.dataset.pulaOrder || '99', 10);
      });
      sorted.forEach(function (s) { parent.appendChild(s); });
    }

    // Desktop: grid li elements
    var gridItems = Array.from(gallery.querySelectorAll('.media-gallery__grid li[data-pula-colorway]'));
    gridItems.forEach(function (li) {
      li.style.display = li.dataset.pulaColorway === colorway ? '' : 'none';
    });

    var matchingGrid = gridItems.filter(function (li) { return li.dataset.pulaColorway === colorway; });
    if (matchingGrid.length > 1) {
      var gridParent = matchingGrid[0].parentNode;
      var sortedGrid = matchingGrid.slice().sort(function (a, b) {
        return parseInt(a.dataset.pulaOrder || '99', 10) - parseInt(b.dataset.pulaOrder || '99', 10);
      });
      sortedGrid.forEach(function (li) { gridParent.appendChild(li); });
    }

    resetSlideshow(gallery);
    requestAnimationFrame(function () { resetSlideshow(gallery); });
  }

  function syncActive(swatches, colorway, container) {
    swatches.forEach(function (s) {
      s.classList.toggle('nc-pula-swatch--active', s.dataset.color.toLowerCase() === colorway);
    });
    var label = container.querySelector('.nc-pula-colorway-name');
    if (label) {
      var active = swatches.find(function (s) { return s.dataset.color.toLowerCase() === colorway; });
      label.textContent = active ? active.dataset.color : colorway;
    }
  }

  function init() {
    loadVariantMap();

    var container = document.querySelector('[data-pula-swatches]');
    if (!container) return;

    var swatches = Array.from(container.querySelectorAll('.nc-pula-swatch'));
    var initialColor = (container.dataset.initialColor || 'livid').toLowerCase();

    applyColorway(initialColor);
    syncActive(swatches, initialColor, container);

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var colorway = this.dataset.color.toLowerCase();
        syncActive(swatches, colorway, container);
        applyColorway(colorway);
        writeVariantId(this.dataset.color);
      });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
